import shop from "@/api/poolOrders";

// initial state
const state = {
    all: [],
    poolFormulas: [],
    poolFormula: {}
};

// getters
const getters = {
    PoolOrder: state => {
        return state.PoolOrder;
    }
};

// actions
const actions = {
    getAllPoolOrders({
        commit
    }) {
        shop.getPoolOrders().then(PoolOrders => {
            commit("getPoolOrders", PoolOrders.data);
        });
    },
    searchPoolOrder: async (context, PoolOrder) => {
        let d = (await shop.searchPoolOrder(PoolOrder)).data;
        context.commit("getPoolOrders", d);
        return d;
    },
    getPoolOrder: async (context, id) => {
        let d = (await shop.getPoolOrder(id)).data;
        context.commit("getPoolOrder", d);
        return d;
    },
    postPoolOrder: async (context, PoolOrder) => {
        const result = (await shop.postPoolOrder(PoolOrder)).data;
        context.commit("postPoolOrder", result);
    },
    postBulkPoolOrder: async (context, PoolOrder) => {
        const result = (await shop.postBulkOrder(PoolOrder.Order)).data;
        context.commit("postPoolOrder", result);
    },
    // putPoolOrder: async (context, PoolOrder) => {
    //     const result = (await shop.postBulkOrder(PoolOrder)).data;
    //     context.commit("bulkInsert", result);
    // },
    deletePoolOrder: async (context, PoolOrder) => {
        (await shop.deletePoolOrder(PoolOrder)).data;
        context.commit("deletePoolOrder", PoolOrder);
    },
    bulkDeletePoolOrder: async (context, PoolOrder) => {
        (await shop.bulkDelete(PoolOrder)).data;
        context.commit("bulkDelete", PoolOrder);
    }


};

// mutations
const mutations = {
    getPoolOrders(state, PoolOrders) {
        state.all = PoolOrders;
    },
    getPoolOrder(state, PoolOrder) {
        //state.PoolOrder = PoolOrder
        state.PoolOrder = null;
        state.PoolOrder = Object.assign({}, state.PoolOrder, PoolOrder);
    },
    postPoolOrder(state, PoolOrder) {
        //state.PoolOrder = PoolOrder
        state.PoolOrder = null;
        state.PoolOrder = Object.assign({}, state.PoolOrder, PoolOrder);
    },
    putPoolOrder(state, PoolOrder) {
        //state.PoolOrder = PoolOrder
        state.PoolOrder = null;
        state.PoolOrder = Object.assign({}, state.PoolOrder, PoolOrder);
    },
    bulkDelete(state, PoolOrder) {
        const item = state.all.filter(d => !PoolOrder.indexOf(d.id));
        item.forEach(element => {
            state.all.splice(state.all.indexOf(element), 1);
        });
    },
    bulkInsert(state, PoolOrder) {
        state.PoolOrder = Object.assign([...state.PoolOrder], [...PoolOrder]);
    },
    deletePoolOrder(state, PoolOrder) {
        state.all.splice(state.all.indexOf(PoolOrder), 1);
    },
    decrementPoolOrderInventory(state, {
        id
    }) {
        const PoolOrder = state.all.find(PoolOrder => PoolOrder.id === id);
        PoolOrder.inventory--;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};